import RightToolbar from "./src/index.vue";

RightToolbar.install = function (Vue) {
  Vue.component(RightToolbar.name, RightToolbar);
};

export default RightToolbar;
